import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'
// import { receiveRoute } from '@m/cabinet/components/views/utils'
// import Receive from '@m/cabinet/components/views/Receive.vue'

export const STAFF_ANALYTICS_MODEL_PATH = 'analytics/'

export const STAFF_ANALYTICS_VIEW_NAME = 'staff:analytics'

// const STAFF_SETTING_USERS_PREFIX = `${STAFF_ANALYTICS_VIEW_NAME}:users`

const prefix = (name: string) => STAFF_ANALYTICS_VIEW_NAME + ':' + name

export const STAFF_ANALYTICS_USERS_LIST_VIEW_NAME = prefix('users')
export const STAFF_ANALYTICS_FACILITIES_LIST_VIEW_NAME = prefix('facilities')
export const STAFF_ANALYTICS_APPOINTMENTS_LIST_VIEW_NAME =
  prefix('appointments')
export const STAFF_ANALYTICS_COMMISSION_LIST_VIEW_NAME = prefix('commission')
export const STAFF_ANALYTICS_INVOICES_LIST_VIEW_NAME = prefix('invoices')
const StaffAnalyticsUsersListView = () => import('./Users/List.vue')
const StaffAnalyticsFacilitiesListView = () => import('./Facilities/List.vue')
const StaffAnalyticsAppointmentsListView = () =>
  import('./Facilities/AppointmentList.vue')
const StaffAnalyticsCommissionListView = () =>
  import('./Facilities/Commissions.vue')
const StaffAnalyticsInvoicesListView = () =>
  import('./Facilities/Invoices.vue')

export function createAnalyticsRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    route(
      'users/',
      StaffAnalyticsUsersListView,
      STAFF_ANALYTICS_USERS_LIST_VIEW_NAME,
      {
        meta: {
          title: () => $t('User registrations on the site'),
        },
      }
    ),
    route(
      'facilities/',
      StaffAnalyticsFacilitiesListView,
      STAFF_ANALYTICS_FACILITIES_LIST_VIEW_NAME,
      {
        meta: {
          title: () => $t('Visiting medical facility pages'),
        },
      }
    ),
    route(
      'commission/',
      StaffAnalyticsCommissionListView,
      STAFF_ANALYTICS_COMMISSION_LIST_VIEW_NAME,
      {
        meta: {
          title: () => $t('Commission'),
        },
      }
    ),
    route(
      'invoices/',
      StaffAnalyticsInvoicesListView,
      STAFF_ANALYTICS_INVOICES_LIST_VIEW_NAME,
      {
        meta: {
          title: () => $t('Invoices issued'),
        },
      }
    ),
    route(
      'appointment/',
      StaffAnalyticsAppointmentsListView,
      STAFF_ANALYTICS_APPOINTMENTS_LIST_VIEW_NAME,
      {
        meta: {
          title: () => $t('Visiting medical facility pages'),
        },
      }
    ),
    // prefixRoutes(
    //   'users/',
    //   [
    //   ],
    //   options
    // ),
  ]
}
